import axios from 'axios';
import { default as documentApi } from '../common/serviceApi';


const discoveryMiiPrompts = {
    notepadFormat: [
      'Please provide your response to the following in bullet points. Do not include the questions in your response. \n' +
      'Identify the most appropriate job title or role based on the given responsibilities.\n\n' +
      'Create an organizational chart in text format, outlining the hierarchy and reporting structure of the company, and show where the role fits in.\n' +
      'What are the key responsibilities and qualifications for success in this role?\n' +
      'Identify high concentration locations in the ASEAN region for the required skill set (including the Philippines) and the estimated monthly salary range (in USD) for individuals with this skill set in the identified locations based on market research and industry trends.\n' +
      'How will the monthly salary compare to the same role in the North America, EMEA and ANZ and the average savings in percentage?\n' +
      'What are the benefits of hiring individuals from the identified locations?\n' +
      'What are the potential risks of hiring individuals with this skill set from the identified locations?\n' +
      'What specific questions would you ask a client to fully understand their requirements for a particular role, and how would you use that information to find the best candidate for the job?.\n'
    ],
    fourRFormat: [
      'Please create a comprehensive Job Description for a role that will address the issues mentioned above.' +
      'Consider all the possible responsibilities this role will have according to industry standards. ' +
      'Use the following format for your response:\n\n' +
      'Role: [appropriate job title]\n\n' +
      'Job Description summary:\n\n' +
      'Responsibilities:\n' +
      '   - [responsibility 1]\n' +
      '   - [responsibility 2]\n' +
      '   - [responsibility 3]\n' +
      '   - [responsibility 4]\n' +
      '   - [responsibility 5]\n\n' +
      'Requirements:\n' +
      '   - [requirement 1]\n' +
      '   - [requirement 2]\n' +
      '   - [requirement 3]\n' +
      '   - [requirement 4]\n' +
      '   - [requirement 5]\n\n' +
      'Results:\n' +
      '   - [measurable outcome 1]\n' +
      '   - [measurable outcome 2]\n' +
      '   - [measurable outcome 3]\n' +
      '   - [measurable outcome 4]\n' +
      '   - [measurable outcome 5]\n\n' +
      'Personal Attributes:\n' +
      '   - [Personal attribute 1]\n' +
      '   - [Personal attribute 2]\n' +
      '   - [Personal attribute 3]\n' +
      '   - [Personal attribute 4]\n' +
      '   - [Personal attribute 5]\n\n'
    ],
    scorecardFormat: [
      'Please create a comprehensive Job Description for a role based on the given job requirements and qualifications. ' +
      'The Job Description should be accurate, appealing to potential candidates.' +
      'Include all possible measurable outcomes based on the job responsibilities. ' +
      'Use the following format for your response starting with:\n' +
      'Job Title: [appropriate Job Tite or role]\n\n' +
      'Job Mission: [job mission statement]\n\n' +
      'Responsibilities:\n' +
      '   - [Responsibility 1]\n' +
      '   - [Responsibility 2]\n' +
      '   - [Responsibility 3]\n' +
      '   - [Responsibility 4]\n' +
      '   - [Responsibility 5]\n\n' +
      'Scorecard (Measurable Outcomes):\n' +
      '   - [measurable outcome 1]\n' +
      '   - [measurable outcome 2]\n' +
      '   - [measurable outcome 3]\n' +
      '   - [measurable outcome 4]\n' +
      '   - [measurable outcome 5]\n\n' +
      'Competencies:\n' +
      '   - [competency 1]\n' +
      '   - [competency 2]\n' +
      '   - [competency 3]\n' +
      '   - [competency 4]\n' +
      '   - [competency 5]\n\n'
    ],
    freeFormFormat: [
      'Provide a summary of the inputs in bullet points.\n' +
      'What should be a good closing statement assuring the client that your company will be able to find the right talent for his requirement?\n\n' +
      'What next steps should you tell the client so that you will continue to engage them?'
    ],
    thankYouFormat: [
      'Please Write me an email thanking the client for the opportunity to gather their requirements.\n' +
      'State in the email that you can provide or supply them the best talent or candidate to solve their challenges and issues.\n\n' +
      'Use the following format for your response:\n' +
      'Dear: [client name],\n\n' +
      '[body of email]\n\n' +
      'Best Regards,\n\n' +
      '[Your name]'
    ],
    nextStepFormat: [
      `As a recruitment agency,\n` +
      `What are the industry's best practices and strategies to persuade clients to choose your agency to provide their talent needs over your competitors?\n` +
      'Use the following format for your response:\n' +
      'Your next steps:\n\n' +
      '[Step 1]\n\n' +
      '[Step 2]\n\n' +
      '[Step 3]\n\n' +
      '[Step 4]\n\n' +
      '[Step 5]\n\n' +
      '[Step 6]\n\n' +
      '[Step 7]\n\n' +
      '[Step 8]\n\n'
    ]
  };

export const generateDiscoveryMiiJobDescriptionRequest = async (prompt, answer, selectedOption) => {
    const getSelectedFormat = discoveryMiiPrompts[selectedOption]
    const finalPrompt = prompt + answer + '. ' + getSelectedFormat[0]
    return await axios.post(`http://localhost:8080/chat`, {
      prompt: finalPrompt
    }).then(response => {
        return response.data
    }).catch(err => {
      return {error: err}
    })
  };

  const getDiscoveryMiiJobDescriptionRequest = async(prompt, answer, selectedOption, options={timeout: 180000}) => {
    const getSelectedFormat = discoveryMiiPrompts[selectedOption]
    const finalPrompt = prompt + answer + '. ' + getSelectedFormat[0]

    const promptObject = {
      "prompt": finalPrompt
    }
    return documentApi.post(`/chat`, promptObject, options)
    .then(request=>{
     return request.data
    })
    .catch(err =>{
      return {error:err}
    })
  }

  export const useDiscoveryMiiService = () => {
    
    const options = {}
    const services = {
      getDiscoveryMiiJobDescriptionRequest
    }

    return [
       { ...services}
    ]
  }

  export const useDiscoveryMii = () => {
    const [  handlers ] = useDiscoveryMiiService()
    return [ handlers ]
  }